import * as React from 'react';
import useTranslator from './useTranslator';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Price(props) {
  const {
    currency,
    children,
    ...extraProps
  } = props;
  const {
    formatPrice
  } = useTranslator();
  return /*#__PURE__*/_jsx("span", {
    ...extraProps,
    children: formatPrice(children, currency)
  });
}